var __jsx = React.createElement;
import React, { useEffect, useRef } from "react";
import { useTranslation } from "@i18n";
import stl from "./AsideTag.module.css";
import { CDN_LINK } from "@globalConfig";
import { replaceTextWithCurrencySymbols } from "@/_MiniApps/CurrencyFont/CurrencyFontProvider";
function AsideTag(_ref) {
  var isDicountTag = _ref.isDicountTag,
    name = _ref.name,
    onClick = _ref.onClick,
    hideDelete = _ref.hideDelete,
    isActiveDiscount = _ref.isActiveDiscount,
    className = _ref.className,
    iconImage = _ref.iconImage,
    _ref$textellipsis = _ref.textellipsis,
    textellipsis = _ref$textellipsis === void 0 ? false : _ref$textellipsis,
    id = _ref.id;
  var _useTranslation = useTranslation(["web_search"]),
    t = _useTranslation.t;
  var nameSpanRef = useRef(null);
  useEffect(function () {
    if (nameSpanRef.current) {
      replaceTextWithCurrencySymbols(name, nameSpanRef.current);
    }
  }, [name]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    id: id,
    title: name,
    onClick: onClick,
    className: [stl.tag, isDicountTag ? stl.dicountTag : stl.blueTag, isActiveDiscount ? stl.activeDiscount : undefined, className ? className : undefined, hideDelete ? stl.disabled : ""].join(" ")
  }, /*#__PURE__*/React.createElement("span", {
    ref: nameSpanRef,
    className: textellipsis ? "md:overflow-hidden md:text-ellipsis md:max-w-[100px] md:whitespace-nowrap" : undefined
  }, name), !hideDelete && /*#__PURE__*/React.createElement("img", {
    src: iconImage ? iconImage : CDN_LINK + "/assets/images/blueX.svg",
    alt: "Delete",
    "aria-label": "Delete"
  }), isActiveDiscount && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/closewhite.svg",
    alt: "Delete",
    width: "15px",
    height: "15px"
  })));
}
export default AsideTag;